export const MEMBER_INFO_DATA = 'MEMBER_INFO_DATA'



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/store/mutations-types.js